module.exports = __webpack_public_path__ + "img/blue4.5e43f3a9.jpg";